import * as React from 'react';
import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { classNames } from 'uitk-react-utils';
import { UitkCard, UitkCardActionArea } from 'uitk-react-cards';
import { UitkHeading } from 'uitk-react-text';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { equals } from '../../../../../../helpers/common-helper';
import { ActivitySpannedTileCardContent } from './activity-spanned-tile-card-content';
import { ActivitySpannedTileCardFeatureHeader } from './activity-spanned-tile-card-feature-header';
import { ActivitySpannedTileCardImage } from './activity-spanned-tile-card-image';
import { CardLink } from '../../card-link';
import { EgdsHeadingTagStyle, VERTICAL_LAYOUT_FALSE, VERTICAL_LAYOUT_TRUE } from '../../../../../../../src/constants';
var ActivitySpannedTileCardComponent = function (_a) {
  var activity = _a.activity,
    className = _a.className,
    onClick = _a.onClick,
    activityGroup = _a.activityGroup;
  var ActivitySpannedTileCardFeatureTileBottom = function () {
    var _a, _b;
    return React.createElement(React.Fragment, null, ((_b = (_a = activity === null || activity === void 0 ? void 0 : activity.features) === null || _a === void 0 ? void 0 : _a.pinnedTopBottom) === null || _b === void 0 ? void 0 : _b.tileBottom) && React.createElement(UitkCardActionArea, {
      className: "uitk-type-300 pinned-bottom",
      "data-testid": "activity-spanned-tile-card-pinned-top-bottom-tile-bottom"
    }, activity.features.pinnedTopBottom.tileBottom.description, React.createElement(UitkIcon, {
      name: activity.features.pinnedTopBottom.tileBottom.id
    })));
  };
  var primary = activity.primary;
  var renderActivityCard = function (isVerticalLayout) {
    if (isVerticalLayout) {
      return React.createElement(React.Fragment, null, React.createElement(UitkSpacing, {
        margin: {
          blockstart: 'two',
          blockend: 'one'
        }
      }, React.createElement(UitkCard, {
        className: classNames('card-overflow-hidden full-width', "".concat(className ? className : '')),
        "data-testid": "activity-spanned-tile-card",
        border: true
      }, React.createElement(ActivitySpannedTileCardFeatureHeader, {
        activity: activity
      }), React.createElement(UitkLayoutFlex, {
        justifyContent: "space-between",
        direction: "column",
        className: "max-height"
      }, React.createElement(UitkHeading, {
        tag: primary.headingType ? EgdsHeadingTagStyle[primary.headingType] : 'h3',
        className: "is-hidden",
        "aria-hidden": "false"
      }, primary.text), React.createElement(ActivitySpannedTileCardImage, {
        activity: activity,
        activityGroup: activityGroup,
        isVerticalLayout: isVerticalLayout
      }), React.createElement(ActivitySpannedTileCardContent, {
        activity: activity,
        activityGroup: activityGroup,
        isVerticalLayout: isVerticalLayout,
        className: className
      }), React.createElement(ActivitySpannedTileCardFeatureTileBottom, null), activity && React.createElement(CardLink, {
        activity: activity,
        onClick: onClick
      })))));
    }
    return React.createElement(React.Fragment, null, React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'six',
        blockend: 'one',
        inline: 'two'
      }
    }, React.createElement(UitkCard, {
      className: classNames('card-overflow-hidden', "".concat(className ? className : '')),
      "data-testid": "activity-spanned-tile-card",
      border: true
    }, React.createElement(UitkHeading, {
      tag: primary.headingType ? EgdsHeadingTagStyle[primary.headingType] : 'h3',
      className: "is-hidden",
      "aria-hidden": "false"
    }, primary.text), React.createElement(ActivitySpannedTileCardFeatureHeader, {
      activity: activity
    }), React.createElement(UitkLayoutGrid, {
      columns: {
        small: 1,
        medium: isVerticalLayout ? VERTICAL_LAYOUT_TRUE : VERTICAL_LAYOUT_FALSE
      }
    }, React.createElement(UitkLayoutGridItem, {
      colSpan: {
        small: 1,
        medium: 1
      }
    }, React.createElement(ActivitySpannedTileCardImage, {
      activity: activity,
      activityGroup: activityGroup,
      isVerticalLayout: isVerticalLayout
    })), React.createElement(ActivitySpannedTileCardContent, {
      activity: activity,
      activityGroup: activityGroup,
      isVerticalLayout: isVerticalLayout,
      className: className
    })), React.createElement(ActivitySpannedTileCardFeatureTileBottom, null), activity && React.createElement(CardLink, {
      activity: activity,
      onClick: onClick
    }))));
  };
  return React.createElement(Viewport, null, React.createElement(ViewSmall, null, renderActivityCard(true)), React.createElement(ViewMedium, null, renderActivityCard(false)));
};
export var ActivitySpannedTileCard = React.memo(ActivitySpannedTileCardComponent, function (prevProps, nextProps) {
  var isActivitySame = Boolean(prevProps.activity) && Boolean(nextProps.activity);
  isActivitySame = isActivitySame || prevProps.activity && nextProps.activity && equals(prevProps.activity.id, nextProps.activity.id);
  return !isActivitySame;
});